<template>
    <span class="succes_card__content">
        <div class="success_card__body">
            <h4 v-if="!friendlyErrorOccurred" class="success_card__title">
                {{ succes_card_title }}
            </h4>
            <p v-if="!email_verification_needed && !put_on_hold" class="success_card__message">
                <t
                    v-if="!friendlyErrorOccurred"
                    text="review_form__success_page__intro"
                    sub="Thanks for your review!"
                />
                <span v-else>{{ friendlyErrorMessage }}</span>
            </p>
            <p
                v-for="message in extra_user_messages"
                v-bind:key="message"
                v-html="message"
                class="success_card__message"
                :class="{
                    'success_card__message--extra-message': !email_verification_needed,
                }"
            ></p>
        </div>
        <div class="discount_code__container" v-if="display_discount_code">
            <h5 class="discount_code_title">
                {{shop.discount_text}}
            </h5>
            <div
                class="discount_code"
                :class="{
                    'discount_code--was-copied': justCopied,
                }"
                @click="copyDiscountCode"
            >
                <div class="discount_code__animation_rail">
                    <div class="discount_code__code">
                        <font-awesome-icon
                            :icon="['fal', 'copy']"
                            class="copy_icon"
                        />
                        {{shop.discount_code}}
                    </div>
                    <div class="discount_code__copied_confirmation">
                        Copied!
                    </div>
                </div>
            </div>
        </div>
    </span>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { setTimeout } from 'timers';
import { mapState } from 'vuex';

const copy = require('clipboard-copy');

library.add(faCopy);

export default {
    name: 'SuccessScreenContent',
    components: {
        FontAwesomeIcon,
    },
    props: {
        extraMessages: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            justCopied: false,
            ComponentLabels: [
                {
                    key: 'review_form__success_page__title',
                    sub: 'Success',
                },
                {
                    key: 'review_form__success_page__title_review_received',
                    sub: 'Review Received',
                },
            ],
        };
    },
    computed: {
        ...mapState({
            friendlyErrorOccurred: state => state.friendlyError.occurred,
            friendlyErrorMessage: state => state.friendlyError.message,
        }),
        shop() {
            return this.$store.state.shop;
        },
        extra_user_messages() {
            return [
                ...this.$store.state.submitResponseData.extra_user_messages || [],
                ...this.extraMessages,
            ];
        },
        email_verification_needed() {
            return this.$store.state.submitResponseData.email_verification_needed;
        },
        put_on_hold() {
            return this.$store.state.submitResponseData.put_on_hold;
        },
        display_discount_code() {
            return (
                this.shop.discount_code !== ''
                && !this.email_verification_needed
                && !this.friendlyErrorOccurred
            );
        },
        succes_card_title() {
            let succesCardTitle = this.$l('review_form__success_page__title', 'Success');
            if (this.extra_user_messages.length) {
                succesCardTitle = this.$l('review_form__success_page__title_review_received', 'Review Received');
            }
            return succesCardTitle;
        },
    },
    methods: {
        copyDiscountCode() {
            const successPromise = copy(this.shop.discount_code);
            successPromise.then(() => {
                this.justCopied = true;
                setTimeout(() => {
                    this.justCopied = false;
                }, 1200);
            });
        },
    },
};
</script>

<style lang="scss" scoped>
    @import "@/style_variables/style_variables.scss";

    .success_card__body {
        padding: 0 60px;
        text-align: inherit;
        @media only screen and (max-width: 600px) {
            padding: 0 12px;
        }
    }
    .success_card__title {
        @extend %headline4_style;
        text-align: inherit;
        margin: 24px 0 0 0;
    }
    .success_card__message {
        @extend %body1_style;
        color: $grey_mineshaft;
        text-align: inherit;
        margin: 16px 0 0 0;
    }
    .success_card__message--extra-message {
        @extend %body2_style;
    }
    .discount_code__container {
        margin: 32px 48px 0;
        padding: 32px 24px;
        background: $white;
        border-radius: 24px;
        border: 1px solid $grey_athens;
        @media only screen and (max-width: 600px) {
            margin: 12px 12px 0;
            padding: 32px 12px;
        }
    }
    .discount_code_title {
        @extend %body1_style;
        text-align: inherit;
        margin: 0;
    }
    .discount_code {
        @extend %body1_style;
        border-radius: 6px;
        padding: 14px 30px;
        margin-top: 16px;
        display: inline-block;
        font-weight: 700;
        font-size: 16px;
        color: $blue;
        border: 1px solid $blue;
        letter-spacing: 0.12px;
        text-align: center;
        transition: all 200ms;

        &:hover {
            @include elevationLevel(2);
            cursor: pointer;
        }
    }
    // Discount Code Animation
    .discount_code {
        height: 58px;
        overflow: hidden;
        width: 100%;
    }
    .discount_code--was-copied {
        .discount_code__animation_rail {
            transform: translateY(-56px);
        }
    }
    .discount_code__animation_rail {
        height: 56 * 2px;
        transition: all 190ms;
        will-change: transform;
    }
    .discount_code__code {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
    .discount_code__code, .discount_code__copied_confirmation {
        height: 56px;
    }
    .copy_icon {
        margin-right: 6px;
    }
</style>
